import { chevronBackOutline } from 'ionicons/icons';
import { addIcons } from 'ionicons';
import {Component, HostListener, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {HelperService} from 'src/shared/services/helpers/helper.service';
import {MenuHelperService} from 'src/shared/services/helpers/menu-helper.service';
import {AuthService} from './core/auth/auth.service';
import {AuthHelperService} from "../shared/services/helpers/auth-helper.service";
import { AlertController } from "@ionic/angular/standalone";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { EventsService } from 'src/shared/services/helpers/events.service';
import { UserDto } from './api/models';
import { IonApp, IonIcon, IonFooter, IonLabel, IonItem, IonSplitPane, IonContent, IonList, IonMenu, IonMenuToggle, IonRouterOutlet } from "@ionic/angular/standalone";
import { LanguageSwitcherComponent } from "../shared/components/elements/language-switcher/language-switcher.component";
import { IconComponent } from "../shared/components/elements/icon/icon.component";
import { HeaderComponent } from "../shared/components/header/header.component";
import { NgFor, NgIf } from '@angular/common';
import { MenuItems } from 'src/shared/models/global.model';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    imports: [IonRouterOutlet, NgFor, TranslatePipe, NgIf, IonList, IonMenu, IonMenuToggle, IonContent, IonSplitPane, IonItem, IonApp, IonLabel, IonFooter, IonIcon, LanguageSwitcherComponent, IconComponent, HeaderComponent],
})
export class AppComponent implements OnInit {
    public appPages: MenuItems[] = [];
    public routerUrl: string;
    public isPublicView: boolean = true;
    public showMenuInPublicView = false;
    public user: UserDto;
    public appVersion: string = '2.14.0.13';

    constructor(
        private authService: AuthService,
        private alertCtrl: AlertController,
        private translate: TranslateService,
        private authHelperService: AuthHelperService,
        private menuService: MenuHelperService,
        private router: Router,
        private eventsService: EventsService,
        private helpService: HelperService,
    ) {
        addIcons({ chevronBackOutline });
        this.authService.$userAuth.subscribe(b => {
			this.isPublicView = !b;
		});
        this.eventsService.$profileObs.subscribe(r => {
            this.user = r;
        });
    }

    ngOnInit() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd){
                this.routerUrl = event.urlAfterRedirects;
            }
        });
        this.authService.$userAuth.subscribe(async b => {
            this.appPages = await this.menuService.getItems(b);
        });
        this.helpService.getCountries();
        this.autoSwitchSidebar(window.innerWidth);
    }

    async logout(e, p) {
        if (p.title === 'sidebar.logout'){
            const alert = await this.alertCtrl.create({
                header: this.translate.instant('alerts.logout-message'),
                cssClass: 'logout-alert-modal',
                mode: 'ios',
                buttons: [
                    {
                        text: this.translate.instant('buttons.cancel'),
                        // cssClass: 'alert-button-outline',
                        handler: () => {
                        },
                    },
                    {
                        text: this.translate.instant('sidebar.logout'),
                        cssClass: 'alert-button-outline',
                        handler: async () => {
                            await this.authHelperService.logout(e, p);
                        },
                    },
                ],
            });

            await alert.present();
        }
        else await this.authHelperService.logout(e, p);
    }
    minimizeSidebar() {
        const panel = document.getElementById('sidebarPanel');
        if (panel?.classList.contains('minimize')) {
          panel.classList.remove('minimize');
        } else {
          panel.classList.add('minimize');
        }
    }      

    @HostListener('window:resize', ['$event.target.innerWidth'])
    autoSwitchSidebar(width) {
        if(width > 1600){
            document.getElementById('sidebarPanel')?.classList.remove('minimize');
        }else {
            document.getElementById('sidebarPanel')?.classList.add('minimize');

        }
        this.showMenuInPublicView = width < 576;
    }
}
